export default __webpack_public_path__ + "Cashback-Aktion MBOS 2026 - Anbieter_08-2026.pdf";